import { styled } from '@mui/material/styles';
import { TabDrawer } from '@aibees/shared/features';

export const Wrapper = styled(TabDrawer)``;
